export const videoCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-laugh-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-mic-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'short', name: '短视频', icon: 'ri-vidicon-line' },
];

export const featuredVideos = [
  {
    id: 1,
    title: '流浪地球3：星际远征',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20stars%20dramatic%20cinematic%20lighting%20deep%20space%20background%20warm%20orange%20and%20gold%20accents%20epic%20scale%20composition&width=800&height=450&seq=video-cover-01&orientation=landscape',
    category: 'movie',
    duration: '02:28:15',
    views: 1280000,
    rating: 9.2,
    quality: '4K',
    description: '人类文明的终极命运，星辰大海中的壮丽史诗',
    updateInfo: '今日更新',
    source: '久久视频',
  },
  {
    id: 2,
    title: '狂飙：风云再起',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20intense%20atmosphere%20dark%20alley%20with%20warm%20street%20lights%20noir%20style%20cinematic%20composition%20mysterious%20mood&width=800&height=450&seq=video-cover-02&orientation=landscape',
    category: 'tv',
    duration: '45:30',
    views: 2560000,
    rating: 9.5,
    quality: '1080P',
    description: '扫黑风暴再度来袭，正义与黑暗的终极对决',
    updateInfo: '更新至38集',
    source: '小蓝视频',
  },
  {
    id: 3,
    title: '姜子牙：封神再临',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animation%20movie%20poster%20epic%20fantasy%20style%20ancient%20Chinese%20gods%20dramatic%20lighting%20golden%20and%20crimson%20color%20palette%20majestic%20composition&width=800&height=450&seq=video-cover-03&orientation=landscape',
    category: 'anime',
    duration: '01:50:22',
    views: 980000,
    rating: 8.9,
    quality: '4K',
    description: '封神宇宙再添力作，国漫巅峰视觉盛宴',
    updateInfo: '热播中',
    source: '豆花视频',
  },
  {
    id: 4,
    title: '地球脉动：深海奇境',
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20deep%20ocean%20scene%20bioluminescent%20creatures%20vibrant%20coral%20reef%20crystal%20clear%20water%20cinematic%20underwater%20photography%20serene%20atmosphere&width=800&height=450&seq=video-cover-04&orientation=landscape',
    category: 'documentary',
    duration: '52:10',
    views: 760000,
    rating: 9.7,
    quality: '4K HDR',
    description: '探索深海未知世界，震撼视觉纪录片巨作',
    updateInfo: '全集上线',
    source: '久久视频',
  },
];

export const hotVideos = [
  {
    id: 5,
    title: '庆余年3：权谋天下',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20ancient%20palace%20intrigue%20rich%20costumes%20warm%20candlelight%20atmosphere%20elegant%20composition%20gold%20and%20red%20color%20scheme&width=640&height=360&seq=video-hot-01&orientation=landscape',
    category: 'tv',
    duration: '48:20',
    views: 3200000,
    rating: 9.6,
    quality: '4K',
    source: '豆花视频',
  },
  {
    id: 6,
    title: '孤注一掷2：暗网追踪',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20cyber%20crime%20theme%20dark%20digital%20aesthetic%20neon%20accents%20on%20dark%20background%20intense%20mood%20cinematic%20composition&width=640&height=360&seq=video-hot-02&orientation=landscape',
    category: 'movie',
    duration: '01:55:40',
    views: 1890000,
    rating: 8.8,
    quality: '1080P',
    source: '久久视频',
  },
  {
    id: 7,
    title: '奔跑吧第12季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20outdoor%20adventure%20vibrant%20colors%20cheerful%20atmosphere%20dynamic%20composition%20bright%20sunlight%20energetic%20mood&width=640&height=360&seq=video-hot-03&orientation=landscape',
    category: 'variety',
    duration: '01:30:00',
    views: 4500000,
    rating: 8.5,
    quality: '1080P',
    source: '小蓝视频',
  },
  {
    id: 8,
    title: '斗破苍穹：炎帝归来',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20animation%20poster%20martial%20arts%20cultivation%20theme%20ancient%20Chinese%20aesthetic%20fire%20and%20flame%20effects%20dramatic%20composition%20warm%20orange%20tones&width=640&height=360&seq=video-hot-04&orientation=landscape',
    category: 'anime',
    duration: '22:15',
    views: 2100000,
    rating: 9.1,
    quality: '1080P',
    source: '豆花视频',
  },
  {
    id: 9,
    title: '舌尖上的中国5',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20delicious%20cuisine%20steaming%20dishes%20warm%20kitchen%20lighting%20rustic%20aesthetic%20appetizing%20composition%20rich%20colors&width=640&height=360&seq=video-hot-05&orientation=landscape',
    category: 'documentary',
    duration: '48:30',
    views: 1650000,
    rating: 9.4,
    quality: '4K',
    source: '久久视频',
  },
  {
    id: 10,
    title: '周处除三害',
    cover: 'https://readdy.ai/api/search-image?query=Taiwanese%20action%20movie%20poster%20crime%20thriller%20dark%20moody%20atmosphere%20urban%20night%20scene%20gritty%20cinematic%20style%20intense%20character%20portrait&width=640&height=360&seq=video-hot-06&orientation=landscape',
    category: 'movie',
    duration: '02:14:08',
    views: 3800000,
    rating: 9.3,
    quality: '4K',
    source: '小蓝视频',
  },
  {
    id: 11,
    title: '长相思：情深缘起',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20fantasy%20drama%20poster%20ancient%20Chinese%20aesthetic%20ethereal%20beauty%20soft%20lighting%20flowing%20robes%20dreamy%20atmosphere%20peach%20blossom%20elements&width=640&height=360&seq=video-hot-07&orientation=landscape',
    category: 'tv',
    duration: '50:15',
    views: 2900000,
    rating: 9.0,
    quality: '4K',
    source: '豆花视频',
  },
  {
    id: 12,
    title: '年会不能停！',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20office%20workplace%20humor%20bright%20colorful%20vibrant%20atmosphere%20corporate%20party%20scene%20fun%20energetic%20composition&width=640&height=360&seq=video-hot-08&orientation=landscape',
    category: 'movie',
    duration: '01:57:30',
    views: 5100000,
    rating: 8.7,
    quality: '1080P',
    source: '久久视频',
  },
];